import {
  ClientPostTypeEnum,
  ClientSuggestionSuggestionStatusEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { APP_NAME } from '@/constants/app';
import { CommentSortEnum } from '@/features/posts/types/commentSort';
import { DorfHelferTypeEnum } from '@/features/posts/types/dorfHelferType';
import { PostFeedType } from '@/features/posts/types/postFeed';

export const postsGermanLocalization = {
  types: {
    [ClientPostTypeEnum.Gossip]: 'Plauderei',
    [ClientPostTypeEnum.Happening]: 'Events',
    [ClientPostTypeEnum.NewsItem]: 'News',
    [ClientPostTypeEnum.Offer]: 'Biete',
    [ClientPostTypeEnum.Seeking]: 'Suche',
    [ClientPostTypeEnum.SpecialPost]: 'Spezial',
    [ClientPostTypeEnum.Suggestion]: "Sag's uns",
    [PostFeedType.MARKET]: 'Markt',
    [PostFeedType.EMERGENCY]: 'Blaulicht',
    [PostFeedType.CIVIL_PROTECTION]: 'Katwarn',
    [PostFeedType.ALL]: 'Alle'
  },
  dorfHelferTypes: {
    [DorfHelferTypeEnum.OFFER]: 'Mach ich',
    [DorfHelferTypeEnum.REQUEST]: 'Brauch ich'
  },
  categories: {
    official: 'Amtliche Meldung'
  },
  screens: {
    'post-detail': {
      options: 'Optionen',
      announceInterest: 'Bin interessiert',
      comments_zero: 'Keine Kommentare',
      comments_one: '1 Kommentar',
      comments_other: '{{count}} Kommentare',
      commentsDisabled: 'Kommentare deaktiviert',
      commentsLimited: 'Kommentare eingeschränkt',
      notVerified: 'Du musst zum Kommentieren verifiziert sein.',
      interestedParticipants_one: '1 Person ist interessiert',
      interestedParticipants_other: '{{count}} Personen sind interessiert',
      learnMore: 'Mehr erfahren',
      onlyIn: 'Nur für {{name}}',
      edited: 'bearbeitet ',
      editedBy: 'Bearbeitet um {{time}} von {{name}}',
      deletedPerson: 'Gelöschtes Konto',
      personBlocked: 'Du hast diese Person blockiert',
      new: '● NEU',
      withdrawReason: 'Zurückziehen',
      commentSort: {
        [CommentSortEnum.NEWEST]: 'Neueste zuerst',
        [CommentSortEnum.OLDEST]: 'Älteste zuerst'
      },
      suggestionStatus: {
        [ClientSuggestionSuggestionStatusEnum.Open]: 'Offen',
        [ClientSuggestionSuggestionStatusEnum.InProgress]: 'In Bearbeitung',
        [ClientSuggestionSuggestionStatusEnum.OnHold]: 'In Bearbeitung',
        [ClientSuggestionSuggestionStatusEnum.Done]: 'Erledigt'
      },
      alerts: {
        commentsLimited: {
          title: 'Kommentare eingeschränkt',
          content:
            'Beiträge im „Sag’s uns“-Kanal ermöglichen den direkten Kontakt zur Gemeindeverwaltung. Damit alles übersichtlich bleibt, dürfen hier nur der/die Author*in oder Mitarbeitende der Verwaltung kommentieren. Wenn du ein eigenes Anliegen hast, kannst du einfach einen neuen Beitrag erstellen.',
          confirm: 'Alles klar'
        },
        delete: {
          title: 'Funk löschen?',
          content:
            'Dein Funk und alle Antworten werden unwiderruflich entfernt.',
          confirm: 'Löschen',
          cancel: 'Abbrechen'
        }
      },
      state: {
        empty: { subtitle: 'Noch still hier –\n teile deine Gedanken!' },
        loading: { title: 'Funk wird geladen' },
        error: {
          title: 'Funk konnte nicht geladen werden',
          subtitle: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
        }
      },
      menu: {
        edit: 'Bearbeiten',
        delete: 'Löschen',
        startChat: 'Privat schreiben',
        block: 'Person blockieren',
        unblock: 'Nicht mehr blockieren',
        report: 'Verstoß melden',
        share: 'Teilen',
        withdraw: 'Zurückziehen'
      },
      share: {
        title: `Schau mal, was {{creatorName}} in {{geoAreaName}} im ${APP_NAME} gepostet hat:`,
        message: {
          postUrl: `Jetzt anschauen: {{postUrl}}`,
          getApp: `${APP_NAME} holen: `
        },
        note: 'Der folgende Text wurde in deine Zwischenablage kopiert:'
      }
    },
    'post-feed': {
      openPost: 'Funk von {{name}} öffnen',
      state: {
        loading: { title: 'Posts werden geladen' },
        error: {
          title: 'Posts konnten nicht geladen werden',
          subtitle:
            'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
          retry: 'Erneut versuchen',
          homeAreaRequired: {
            title: 'Heimatort nicht gesetzt',
            subtitle:
              'Bitte setze einen Heimatort, um Ministerien-Inhalte zu sehen.'
          }
        }
      },
      offer: 'Angebot',
      seeking: 'Suche'
    },
    'post-search': {
      placeholder: 'Suche nach Funks',
      hint: 'Gib min. 3 Buchstaben ein...'
    },
    'happening-participants': {
      participants_one: '1 Person ',
      participants_other: '{{count}} Personen'
    }
  },
  components: {
    commentItem: {
      deleted: 'Kommentar wurde gelöscht.',
      deletedPerson: 'Gelöschtes Konto',
      personBlocked: 'Du hast diese Person blockiert',
      startChat: 'Privat schreiben',
      reply: 'Auf Kommentar antworten',
      report: 'Verstoß melden',
      block: 'Person blockieren',
      unblock: 'Person nicht mehr blockieren',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      edited: 'bearbeitet ',
      editedBy: 'Bearbeitet um {{time}} von {{name}}',
      alerts: {
        commentDeletion: {
          title: 'Kommentar löschen',
          content: 'Willst Du wirklich Deinen Kommentar löschen?',
          confirm: 'Löschen',
          cancel: 'Abbrechen'
        }
      }
    },
    commentEditor: {
      hint: 'Kommentieren...',
      replyTo: '{{personName}} antworten',
      editing: 'Bearbeiten',
      menu: {
        selectAttachment: 'Anhang auswählen',
        selectImage: 'Bild aus Bibliothek auswählen',
        take: 'Foto aufnehmen'
      },
      accessibility: {
        editorHint: 'Kommentartext eingeben',
        editorLabel: 'Kommentartext'
      },
      alerts: {
        documentSize: {
          title: 'Datei zu groß',
          content: 'Die Datei darf maximal {{maxSizeKb}} KB groß sein.',
          confirm: 'OK'
        }
      }
    },
    suggestionWithdraw: {
      accessibility: {
        editorHint:
          'Beschreibe den Grund für das Zurückziehen deines Anliegens.',
        editorLabel: 'Grund für Zurückziehen'
      },
      description: 'Grund',
      descriptionHint:
        'Bitte erläutere den Mitarbeiter*innen der Gemeinde kurz, ob sich dein Anliegen bereits erledigt hat oder ob noch etwas zu tun ist.',
      withdraw: 'Anliegen zurückziehen',
      toasts: {
        withdraw: {
          success: 'Funk erfolgreich zurückgezogen.',
          error: 'Funk konnte nicht zurückgezogen werden'
        }
      }
    },
    poll: {
      voteCount: '{{percentage}}% ({{votes}})',
      vote: 'Ergebnisse anzeigen ({{voterCount}})',
      results: 'Zur Umfrage',
      send: 'Absenden',
      change: 'Auswahl ändern'
    },
    postDaySeparator: {
      today: 'Heute',
      yesterday: 'Gestern'
    },
    postCardHeader: {
      accessibility: {
        organizationHint: 'Profil von {{name}} öffnen'
      }
    }
  }
};

// Guarantees that both translations have the same structure
type PostsLocalization = typeof postsGermanLocalization;

export const postsEnglishLocalization: PostsLocalization = {
  types: {
    [ClientPostTypeEnum.Gossip]: 'Plauderei',
    [ClientPostTypeEnum.Happening]: 'Events',
    [ClientPostTypeEnum.NewsItem]: 'News',
    [ClientPostTypeEnum.Offer]: 'Offer',
    [ClientPostTypeEnum.Seeking]: 'Seeking',
    [ClientPostTypeEnum.SpecialPost]: 'Spezial',
    [ClientPostTypeEnum.Suggestion]: 'Suggestion',
    [PostFeedType.MARKET]: 'Market',
    [PostFeedType.EMERGENCY]: 'Public Safety',
    [PostFeedType.CIVIL_PROTECTION]: 'Civil protection',
    [PostFeedType.ALL]: 'Alle'
  },
  dorfHelferTypes: {
    [DorfHelferTypeEnum.OFFER]: 'I provide',
    [DorfHelferTypeEnum.REQUEST]: 'I need'
  },
  categories: {
    official: 'Official notice'
  },
  screens: {
    'post-detail': {
      options: 'Options',
      announceInterest: "I'm interested",
      comments_zero: 'No comments',
      comments_one: '1 comment',
      comments_other: '{{count}} comments',
      commentsDisabled: 'Comments deactivated',
      commentsLimited: 'Comments limited',
      notVerified: 'You need to be verified to comment.',
      interestedParticipants_one: '1 person is interested',
      interestedParticipants_other: '{{count}} persons are interested',
      learnMore: 'Learn more',
      onlyIn: 'Only in',
      edited: 'edited ',
      editedBy: 'Edited at {{time}} by {{name}}',
      deletedPerson: 'Deleted account',
      personBlocked: 'You have blocked this person',
      new: '● NEW',
      withdrawReason: 'Withdraw',
      commentSort: {
        [CommentSortEnum.NEWEST]: 'Newest first',
        [CommentSortEnum.OLDEST]: 'Oldest first'
      },
      suggestionStatus: {
        [ClientSuggestionSuggestionStatusEnum.Open]: 'Open',
        [ClientSuggestionSuggestionStatusEnum.InProgress]: 'In progress',
        [ClientSuggestionSuggestionStatusEnum.OnHold]: 'In progress',
        [ClientSuggestionSuggestionStatusEnum.Done]: 'Done'
      },
      alerts: {
        commentsLimited: {
          title: 'Comments limited',
          content:
            'Posts in the “Suggestion” channel enable direct contact with the municipal administration. To keep everything clear, only the author or employees of the administration are allowed to comment here. If you have your own concern, you can simply create a new post.',
          confirm: 'Okay'
        },
        delete: {
          title: 'Delete Post?',
          content: 'Your Post and all replies will be permanently removed.',
          confirm: 'Delete',
          cancel: 'Cancel'
        }
      },
      state: {
        empty: { subtitle: 'Still quiet here –\n share your thoughts!' },
        loading: { title: 'Post is loading' },
        error: {
          title: 'Post could not be loaded',
          subtitle: 'Please try again later.'
        }
      },
      menu: {
        edit: 'Edit',
        delete: 'Delete',
        startChat: 'Message privately',
        block: 'Block person',
        unblock: 'Unblock person',
        report: 'Report violation',
        share: 'Share',
        withdraw: 'Withdraw'
      },
      share: {
        title: `Look what {{creatorName}} posted in {{geoAreaName}} on ${APP_NAME}:`,
        message: {
          postUrl: `Check it out now: {{postUrl}}`,
          getApp: `Get ${APP_NAME}: `
        },
        note: 'The following text has been copied to your clipboard:'
      }
    },
    'post-feed': {
      openPost: 'Open post by {{name}}',
      state: {
        loading: { title: 'Posts are loading' },
        error: {
          title: 'Posts could not be loaded',
          subtitle: 'Please try again later.',
          retry: 'Try again',
          homeAreaRequired: {
            title: 'Home area not set',
            subtitle: 'Please set a home area to see ministry content.'
          }
        }
      },

      offer: 'Offer',
      seeking: 'Seeking'
    },
    'post-search': {
      placeholder: 'Search for posts',
      hint: 'Enter at least 3 letters...'
    },
    'happening-participants': {
      participants_one: '1 person ',
      participants_other: '{{count}} persons'
    }
  },

  components: {
    commentItem: {
      deleted: 'Comment deleted',
      deletedPerson: 'Deleted account',
      personBlocked: 'You have blocked this person',
      startChat: 'Message privately',
      reply: 'Reply to comment',
      report: 'Report violation',
      block: 'Block person',
      unblock: 'Unblock person',
      delete: 'Delete',
      edit: 'Edit',
      edited: 'edited ',
      editedBy: 'Edited at {{time}} by {{name}}',
      alerts: {
        commentDeletion: {
          title: 'Delete comment',
          content: 'Do you really want to delete your comment?',
          confirm: 'Delete',
          cancel: 'Cancel'
        }
      }
    },
    commentEditor: {
      hint: 'Comment...',
      replyTo: 'Reply to {{personName}}',
      editing: 'Editing',
      menu: {
        selectAttachment: 'Select attachment',
        selectImage: 'Select image from library',
        take: 'Take a photo'
      },
      accessibility: {
        editorHint: 'Enter comment text',
        editorLabel: 'Comment text'
      },
      alerts: {
        documentSize: {
          title: 'File too big',
          content: 'File size must not exceed {{maxSizeKb}} KB.',
          confirm: 'OK'
        }
      }
    },
    suggestionWithdraw: {
      accessibility: {
        editorHint: 'Describe the reason for withdrawing this inquiry.',
        editorLabel: 'Reason for withdrawal'
      },
      description: 'Reason',
      descriptionHint:
        'Please explain to the employees of the municipality, if your inquiry is already dealt with or if there is something left to do.',
      withdraw: 'Anliegen zurückziehen',
      toasts: {
        withdraw: {
          success: 'Post was successfully withdrawn',
          error: 'Post could not be withdrawn'
        }
      }
    },
    poll: {
      voteCount: '{{percentage}}% ({{votes}})',
      vote: 'Show results ({{voterCount}})',
      results: 'Go to poll',
      send: 'Send',
      change: 'Change vote'
    },
    postDaySeparator: {
      today: 'Today',
      yesterday: 'Yesterday'
    },
    postCardHeader: {
      accessibility: {
        organizationHint: 'Open profile of {{name}}'
      }
    }
  }
};
